// useCustomerFormSchema.ts
import { z } from 'zod';
import { useValidationSchemas } from '@/shared/hooks/useValidation';
import { useTranslation } from 'react-i18next';

export function UseCustomerFormSchema() {
  const { validateName, validateEmail, validateZipCode, validateAddress, customerStatusEnum } = useValidationSchemas();
  const { t } = useTranslation('customers');

  const customerFormSchema = z.object({
    firstName: validateName(t('form.firstName')),
    lastName: z.string().min(1, t('form.errors.lastNameRequired')),
    streetAddress: validateAddress(t('form.address'), 1),
    zipCode: validateZipCode(t('form.postalCode')),
    city: validateName(t('form.city')),
    email: validateEmail(),
    energyProviderEmail: z
      .email(t('form.errors.invalidEmail'))
      .optional()
      .or(z.literal('')),
    energyProviderName: z
      .string()
      .max(100, t('form.errors.maxLength', { length: 100 }))
      .optional(),
    energyProviderCustomerId: z
      .string()
      .max(100, t('form.errors.maxLength', { length: 100 }))
      .optional(),
    isPayoutDisabled: z.boolean().optional(),
    isYearlyBillDisabled:z.boolean().optional(),
  });

  const customerIdSchema = z.object({
    id: z.string().min(1, 'Customer ID is required'),
  });

  const customerFilterSchema = z.object({
    search: z.string().optional(),
    status: z.enum(customerStatusEnum).optional(),
    company: z.string().optional(),
  });

  const customerListParamsSchema = z.object({
    page: z.number().min(1).optional(),
    limit: z.number().min(1).max(100).optional(),
    search: z.string().optional(),
    status: z.enum(customerStatusEnum).optional(),
    sortBy: z
      .enum(['firstName', 'lastName', 'email', 'createdAt', 'totalSpent'])
      .optional(),
    sortOrder: z.enum(['asc', 'desc']).optional(),
  });

  return {
    customerFormSchema,
    customerIdSchema,
    customerFilterSchema,
    customerListParamsSchema,
  };
}
